import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Asset, Zone } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../../../../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from 'src/app/features/security-zone/secure-zone-api-endpoints';


interface GetZonesResponse {
  zones: Zone[];
}

interface GetZoneResponse {
  zone: Zone;
}

export interface ZoneMappingRequest {
  securityZoneIds: string[];
  assetIds: string[];
  environmentIds: string[];
  securityZoneId: string;
}

export interface MappingItem {
  id?: string;
  name?: string;
  zoneName?: string;
  assetId?: string;
  assetName?: string;
  description ?: string;
  assetStatus ?: string;
  businessValue ?: string;
  dataClassification ?: string;
   platform ?: string;
}

export interface ZoneMappingsResponse {
  securityZoneId: string;
  environments: MappingItem[];
  assets: MappingItem[];
  securityZones : MappingItem[];
}


@Injectable({
  providedIn: 'root'
})
export class ZoneService {
  private readonly apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

  getZones(currentPage: number): Observable<Zone[]> {
    return this.http.post<GetZonesResponse>(`${this.apiUrl}${API_ENDPOINTS.ZONE.FETCH}`, { currentPage })
      .pipe(
        map(response => response.zones),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }
  

  getZone(securityZoneId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GET}`,{securityZoneId})
      .pipe(
        map(response => response.zone),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }


  getZonesSearch(currentPage: number, searchText: String, filterByHeader: String): Observable<Zone[]> {
    return this.http.post<GetZonesResponse>(`${this.apiUrl}${API_ENDPOINTS.ZONE.SEARCH}`, { currentPage, searchText, filterByHeader })
      .pipe(
        map(response => response.zones),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }


  createZone(zoneName: string, description: string, securityZoneTypeId:string,platformName:string ,risk:string, environmentIds: string[], assetIds: string[] ): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ZONE.CREATE}`, { zoneName, description, securityZoneTypeId, platformName, risk, environmentIds, assetIds })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  updateZone(zoneId:string, zoneName: string, description: string, securityZoneTypeId:string,platformName:string ,risk:string, environmentIds: string[], assetIds: string[] ): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ZONE.UPDATE}`, { zoneId, zoneName, description, securityZoneTypeId, platformName, risk, environmentIds, assetIds })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
       ); 
  }

   getPlatformsBySecurityZoneType(
  securityZoneTypeName: string
): Observable<any> {

    return this.http.post<any>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GETPLATFORMSBYSECURITYZONETYPE}`,{ securityZoneTypeName})
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
}

  getSecurityZoneTypes(){
    return this.http.post<any>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GETSECURITYZONETYPES}`,{})
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }



  deleteZone(zoneId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${API_ENDPOINTS.ZONE.DELETE}`, { zoneId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
       ); 
  }



    getZoneAssetsByZoneId(zoneId: string): Observable<Asset[]> {
      return this.http.post<Asset[]>(`${this.apiUrl}${API_ENDPOINTS.ZONE.GETZONEASSETSBYZONEID}`, { zoneId })
        .pipe(
          map(response => response),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }

  //************************************************************************************************************************************* */




 

  

}